import { createPortal } from "react-dom";

// Renders a modal at the top of the page (document.body), so the sidebar and
// page layers can never cover it.
export default function Portal({ children }) {
  return createPortal(children, document.body);
}
